import React from "react";
import { Card, Spin, Statistic } from "antd";

const TotalsSummary = ({ data, loading, title = "Summary" }) => {
  const formatValue = (label, value, sign) => {
    if (loading) return <Spin />;
    if (value === null || value === " " || value === "" || value === undefined)
      return " ";
    if (sign === "percentage") {
      // Ensure value is a number before calling toFixed
      const numValue = Number(value);
      return `${!isNaN(numValue) ? numValue.toFixed(2) : 0}%`;
    } else if (sign === "dollar") {
      const numValue = Number(value);
      return `$${!isNaN(numValue) ? numValue.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) : '0.00'}`;
    } else if (sign === "integer") {
      const numValue = Number(value);
      return !isNaN(numValue) ? numValue.toLocaleString(undefined) : '0';
    } else {
      const numValue = Number(value);
      if (!Number.isInteger(numValue)) {
        return numValue.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return value;
    }
  };

  return (
    <Card variant="outlined" title={title} loading={loading}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          gap: "16px",
        }}
      >
        {data?.map((item, index) => (
          <div
            key={index}
            style={{
              border: item.empty ? "none" : "1px solid #ddd",
              padding: "10px",
              textAlign: "center",
              minHeight: "50px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Statistic
              title={item.label}
              value={formatValue(item.label, item.value, item.sign)}
              valueStyle={{ fontSize: 14 }}
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default TotalsSummary;
